import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { clearService, setService } from "../../redux/slices/service";

import { startAutoLogin } from '../../redux/slices/auth';

export const Soo = () => {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const membresia = searchParams.get("membresia");
  const idCita = searchParams.get("idCita");
  const idReunionZoom = searchParams.get("idReunionZoom");
  const passwordReunionZoom = searchParams.get("passwordReunionZoom");

  const hasValue = (value) => value && value.trim() !== "";

  useEffect(() => {

    const processSso = async () => {

        if (!token) {

            dispatch(clearService());
            navigate("/", { replace: true });
            return;

        }

        localStorage.setItem("token", token);

        await dispatch(startAutoLogin());

        if (!membresia || !idCita || !idReunionZoom || !passwordReunionZoom) {

            dispatch(clearService());
            navigate("/", { replace: true });
            return;

        }

        if (hasValue(membresia) && hasValue(idCita) && hasValue(idReunionZoom) && hasValue(passwordReunionZoom)) {

            dispatch(setService({
                modulo: '',
                membresia: membresia,
                idCita: idCita,
                idReunionZoom: idReunionZoom,
                passwordReunionZoom: passwordReunionZoom,
                urlReunionZoom: '',
                origin: 'SSO'
            }));

            navigate("/webcall", { replace: true });

        }else{

            dispatch(clearService());
            navigate("/", { replace: true });
            return;

        }

    };

    processSso();

  }, [
    token,
    membresia,
    idCita,
    idReunionZoom,
    passwordReunionZoom,
    dispatch,
    navigate,
  ]);

  return (
    <div className='mt-5'>Autenticación de usuario...</div>
  )
}
